export const formatRows = (listaItems) => {
  const ahora = new Date();

  return listaItems.map((item) => {
    const hasta = new Date(item.aof_oferta_hasta);
 
    return {
      id: item.id,
      aof_nombre: item.aof_nombre,
      aof_tipo: item.aof_tipo,
      aof_tipoprecio: item.aof_tipoprecio,
      estado: hasta > ahora ? "Vigente" : "Vencida", 
      web: item.aof_show_web === 0 ? "✅" : "❌",
    app: item.aof_show_app === 0 ? "✅" : "❌",
    };
  });
};